import React, { useEffect, useState, ReactNode, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, round } from 'lodash';

import './scss/capital-analysis.scss';
import SubTitle from '../component/sub-title';
import Color from '@/tool/color';

import Tab from '../component/tab';
import TimeTab from '../component/time-tab';
import moCapital, {
  changeDefalutDatas,
  changeModel,
  changeShowCapital,
  changeTab,
  changeTimeTab,
} from './store/capital-analysis';
import CapitalChart from './component/capital-chart';
import CommonTable from '../component/common-table';
import { BrowseIcon } from '@/styled/icon';
import moEffect from '../store';
import HeadTable from '../component/head-table';
import WorkService from '@/service/work';
import Empty from '@/component/empty';
import { toJS } from 'mobx';
import { exportExcelFile } from '@/tool';
import moMenu from '../store/menu';

interface IProps {}
interface IState {}

const CapitalAnalysis = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { capitalTabActive, capitalTimeActive, capActiveShow, capitalList } =
    moCapital;

  const tabList = ['人均营业收入', '人均净利润', '元均营业收入', '元均净利润'];

  const tabChange = (val: string) => {
    changeTab(val);
  };

  const timeTabChange = (val: string) => {
    changeTimeTab(val);
  };

  // 打开数据弹框

  const openDataModel = () => {
    changeModel(true);
    WorkService.userData().then((res: any) => {
      changeDefalutDatas(res);
    });
  };

  const changeTableShow = (val: string) => {
    changeShowCapital(val);
  };

  const emen: any = {
    人均营业收入: 'revenue_per_staff',
    人均净利润: 'profit_per_staff',
    元均营业收入: 'revenue_per_yuan',
    元均净利润: 'profit_per_yuan',
  };
  const active = emen[capitalTabActive];
  const getData = useMemo(() => {
    let data: any = {
      red: 0,
      redRate: 0,
      yellow: 0,
      yellowRate: 0,
      blue: 0,
      blueRate: 0,
    };
    if (!isEmpty(capitalList)) {
      const list = capitalList?.chart_data[active];
      const redLength = list.filter((res: any) => res.flag === '红牌区').length;
      const yellowLength = list.filter(
        (res: any) => res.flag === '警戒区',
      ).length;
      const blueLength = list.filter(
        (res: any) => res.flag === '预期区',
      ).length;
      const rRate = (redLength * 100) / (redLength + yellowLength + blueLength);
      const yRate =
        (yellowLength * 100) / (redLength + yellowLength + blueLength);
      const bRate =
        (blueLength * 100) / (redLength + yellowLength + blueLength);
      data = {
        red: redLength,
        redRate: rRate ? round(rRate, 1) : 0,
        yellow: yellowLength,
        yellowRate: yRate ? round(yRate, 1) : 0,
        blue: blueLength,
        blueRate: bRate ? round(bRate, 1) : 0,
      };
    }
    return data;
  }, [capitalList, capitalTabActive]);

  const contentList = [
    '预期区：薪酬投入水平与业绩产出水平匹配',
    '警戒区：薪酬投入水平与业绩产出水平基本匹配，但存在较大优化改善空间',
    '红牌区：薪酬投入水平与业绩产出水平不匹配，高业绩产出对应低薪酬投入，低业绩产出对应高薪酬投入',
  ];

  const tableList = useMemo(() => {
    let list: any = [];
    if (!isEmpty(capitalList?.table_data)) {
      list = [
        capitalList?.table_data?.revenue_per_staff,
        capitalList?.table_data?.profit_per_staff,
        capitalList?.table_data?.cost_per_staff,
        capitalList?.table_data?.revenue_per_yuan,
        capitalList?.table_data?.profit_per_yuan,
      ];
    }
    const data = capitalList?.table_data?.profit_per_staff?.map(
      (res: any, r: any) => {
        const item: any = {};
        item.industry = res.company_name;
        const subList: any = [];
        list?.forEach((ele: any, e: number) => {
          subList.push({
            value: e > 2 ? round(ele[r].value, 1) : round(ele[r].value, 0),
            quantile: ele[r].quantile,
          });
        });
        item.child = subList;
        return item;
      },
    );
    return data;
  }, [capitalList]);

  const myCompany = useMemo(() => {
    let area = '';
    const active = emen[capitalTabActive];
    if (!isEmpty(capitalList?.chart_data)) {
      const list = capitalList?.chart_data[active]?.filter(
        (res: any) => res.company_name === '您所在公司',
      );
      area = !isEmpty(list) && list[0].flag;
    }
    return area;
  }, [capitalList, capitalTabActive]);

  const exporttable = () => {
    const head:any = [
      ['', '人均营业收入', '', '人均净利润',  '', '人均薪酬成本', '', '元均营业收入', '', '元均净利润', ''],
      ['公司名称', '绝对值', '分位值', '绝对值', '分位值', '绝对值', '分位值', '绝对值', '分位值', '绝对值', '分位值'],
    ];
    const content :any = [];
    tableList.forEach((item:any) => {
      const items:any = [item.industry];
      item.child?.forEach((ele:any) => {
        items.push(ele.value && ele.value !== 0 ? ele.value : '-');
        items.push( ele.quantile && ele.quantile !== 0 ? ele.quantile : '-');
      });
      content.push(items);
    });
    const list:any = [...head, ...content];
    const merge = [
      { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
      { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },
      { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } },
      { s: { r: 0, c: 7 }, e: { r: 0, c: 8 } },
      { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } },
    ];
    exportExcelFile(list, merge, '人力资本回报分析');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id="effect04" className="capital-analysis-warp human-common">
      <section className="capital-top">
        <SubTitle
          title="人力资本回报分析"
          subtitle={moMenu.industryName}
          bg={Color.primaryColor(0.1)}
          color={Color.primary}
          active={capActiveShow}
          tabChange={changeTableShow}
          contentList={capActiveShow === 'chart' ? contentList : []}/>
        {capActiveShow === 'chart' && (
          <p onClick={openDataModel} className="add-date">
            添加我的数据
          </p>
        )}
      </section>

      {capActiveShow === 'chart' && (
        <section className="tabs">
          <Tab list={tabList} active={capitalTabActive} onChange={tabChange} />
        </section>
      )}

      {capActiveShow === 'chart' ? (
        <section className="chart-demo">
          {!isEmpty(capitalList?.chart_data) &&
          !isEmpty(capitalList?.chart_data[active]) ? (
              <section className="chart">
                <CapitalChart />
              </section>
            ) : (
              <Empty />
            )}
          {!isEmpty(capitalList?.chart_data) &&
            !isEmpty(capitalList?.chart_data[active]) && (
            <section className="chart-detail capital-detail">
              <section className="item">
                <b />
                <p>
                  <span>红牌区的公司有</span>
                  <span className="t-red">{getData?.red}</span>
                  <span>家，占比</span>
                  <span className="t-red">{getData?.redRate}%</span>
                </p>
              </section>
              <section className="item">
                <b />
                <p>
                  <span>警戒区的公司有</span>
                  <span className="t-yellow">{getData?.yellow}</span>
                  <span>家，占比</span>
                  <span className="t-yellow">{getData?.yellowRate}%</span>
                </p>
              </section>
              <section className="item">
                <b />
                <p>
                  <span>预期区的公司有</span>
                  <span className="t-blue">{getData?.blue}</span>
                  <span>家，占比</span>
                  <span className="t-blue">{getData?.blueRate}%</span>
                </p>
              </section>
              {myCompany && (
                <section className="item active">
                  <b />
                  <p>
                    <span>您所在公司处于</span>
                    {myCompany === '红牌区' && (
                      <span className={myCompany === '红牌区' ? 't-red' : ''}>
                        {myCompany}
                      </span>
                    )}
                    {myCompany === '警戒区' && (
                      <span
                        className={myCompany === '警戒区' ? 't-yellow' : ''}>
                        {myCompany}
                      </span>
                    )}
                    {myCompany === '预期区' && (
                      <span
                        className={myCompany === '预期区' ? 't-blue' : ''}>
                        {myCompany}
                      </span>
                    )}
                  </p>
                </section>
              )}
            </section>
          )}
        </section>
      ) :
        <section>
          {capActiveShow === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}
          {!isEmpty(capitalList?.table_data) && (
            <HeadTable
              subList={['绝对值', '分位值']}
              emeuList={['value', 'quantile']}
              oneList={['公司名称']}
              emeuoneList={['industry']}
              list={tableList}
              title={[
                '人均营业收入',
                '人均净利润',
                '人均薪酬成本',
                '元均营业收入',
                '元均净利润',
              ]}
              width={20}/>)}
        </section>
      }

      <section className="time-tabs">
        <TimeTab
          list={moEffect.yearList}
          active={capitalTimeActive}
          onChange={timeTabChange}/>
      </section>
    </section>
  );
};

export default observer(CapitalAnalysis);
